import { OBJECT_SCREEN_TAB_SEARCH_PARAM } from '../../../components/v2/layout/ObjectScreen/objectScreen.constants';
import { OrderView } from '../ordersView.types';
import { GetOrderTabPathParams } from './orderTabPath.types';

export const getOrderTabPath = ({ orderId, tab, params = [] }: GetOrderTabPathParams) => {
  const searchParams = new URLSearchParams({ [OBJECT_SCREEN_TAB_SEARCH_PARAM]: tab });

  params.forEach(([key, value]) => searchParams.append(key, value));

  return `/orders/${orderId}/${OrderView.EDIT}?${searchParams}`;
};
